'use strict';

angular.module('amexReconciliationApp')
  .component('transactionReceiptIcon', {
    templateUrl: 'scripts/views/components/transaction-receipt-icon.html',
    bindings: {
      transaction: '<',
      transactionIndex: '<'
    },
    controller: function (UploadingTransactionReceiptsModel, $state, $window) {

      var self = this;

      self.receiptsPresent = function() {
        return receiptCount() > 0;
      };

      self.isUploading = function () {
        return UploadingTransactionReceiptsModel.hasReceiptsUploading(self.transaction);
      };
      
      self.goToReceipts = function() {
        $state.go('transactions.overview.receipts', {
          transactionId: self.transaction.id,
          index: self.transactionIndex
        });
      };

      self.getReceiptUrl = function() {
        return '/api/v1/receipts/' + self.transaction.receiptIds[0] + '/image';
      };

      self.hasSingleReceipt = function() {
        return (receiptCount() === 1);
      };

      function receiptCount() {
        return _.get(self.transaction, 'receiptIds', []).length;
      }

      self.receiptTooltip = self.receiptsPresent() ? 'transactions.titles.ReceiptUploaded' : 'transactions.titles.NeedsReceipt';

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionReceiptIcon.js
// module id = 496
// module chunks = 0